export default __webpack_public_path__ + "static/media/item_2.b35ef885.png";